import { connect } from "react-redux";

import {
  editOrganization,
  getOrganizationDetails,
  getOrganizationUsers,
  getOrganizationWorkspaces,
} from "../../store/organization/duck";
import { removeOrganizationMember, updateOrganizationMember } from "../../store/organizationMember/duck";
import {
  addSocialMediaPlatforms,
  addUsers,
  createIllustoAccount,
  createSocialProfile,
  createStorage,
  createStorageAdmin,
  createUserProfile,
  deleteSocialProfile,
  deleteStorage,
  deleteStorageAdmin,
  deleteUserProfile,
  editStorageDetails,
  editStorageDetailsAdmin,
  editUserProfile,
  fetchMe,
  fetchUserDetails,
  getAllDatafeedConfigsForOrganization,
  getAssignedStorageOrganization,
  getAssignedUserOfStorage,
  getClientSetting,
  getDownloadVideosCSV,
  getFeatureList,
  getFolder,
  getOrganization,
  getOrganizationConfigCategory,
  getOrganizationListById,
  getOrganizationsByIds,
  getOrganizationStorage,
  getPackages,
  getSocialProfiles,
  getStorage,
  getStorageList,
  getUser,
  getUsersByOrganization,
  getUsersByUserIds,
  getWorkspaceConfigCategory,
  getYoutubeDownloadVideosData,
  importS3GlacierStreams,
  resetUserPassword,
  resyncIllustoResource,
  storageValidation,
  syncTv2PlayerData,
  updateClientSetting,
  updateOrganization,
  updateSocialProfile,
  updateStorageMultipleFolderPath,
  updateUser,
  updateUsers,
  validateUserAuthentication,
} from "../../store/user/duck";
import {
  addAudioToFolder,
  addBulkTeam,
  addBulkTournament,
  addEvent,
  addImages,
  addMediaTemplate,
  addNewUser,
  addShow,
  addSlate,
  addSport,
  addTagThroughCSV,
  addTenant,
  assignCategoryToOrganization,
  createCustomFields,
  createPlayer,
  createReservedChannle,
  createRTMPChannel,
  createServer,
  createTeam,
  createTournament,
  deleteAudio,
  deleteCategory,
  deleteFields,
  deleteImages,
  deleteKeymoment,
  deleteMediaTemplate,
  deletePlayers,
  deleteReservedChannel,
  deleteRTMPChannel,
  deleteSecretValue,
  deleteServer,
  deleteShows,
  deleteSlate,
  deleteStoryTemplate,
  deleteTagsById,
  deleteTeam,
  deleteTeamById,
  deleteTenant,
  deleteTournamentData,
  editMediaTemplate,
  editReservedChannel,
  editShow,
  editTeamById,
  fetchBrightCoveToken,
  fetchSecretValues,
  fetchSportsTeam,
  fetchTemplateConfig,
  fetchTournamentsData,
  getAllCategory,
  getAllInviteUser,
  getAllTagsById,
  getAllTeams,
  getAllTournament,
  getAudio,
  getCategoryConfiguration,
  getChannelDetails,
  getCreateCategory,
  getCreateTeams,
  getCreateTournament,
  getCustomFields,
  getDeleteTournament,
  getEditTournament,
  getEventsByCategory,
  getEventStream,
  getImages,
  getMediaTemplate,
  getOrgDetails,
  getPlayersByEvents,
  getPlayerStream,
  getRTMPChannel,
  getServerDetails,
  getShows,
  getSingleOrganizationById,
  getSportsDetail,
  getStoryTemplates,
  getTenant,
  getTimeLineDuration,
  getTotalTeams,
  getUploadPicture,
  getUserDetail,
  getVideoGridState,
  isValidStream,
  listReservedChannel,
  moveStoryTemplate,
  showSlate,
  testStoryTemplate,
  updateCategoryConfiguration,
  updateCustomFields,
  updatertmpChannel,
  updateRTMPState,
  updateTenant,
  updateVideoData,
  uploadStoryTemplate,
} from "../../store/videogrid/duck";
import { editWorkspace, getWorkspaceDetails, getWorkspaces, getWorkspaceUsers } from "../../store/workspace/duck";
import { removeWorkspaceMember, updateWorkspaceMember } from "../../store/workspaceMember/duck";
import OrganisationProfileComponent from "./component";

const OrganisationProfile = connect(
  // Map state to props
  (/*state*/) => ({}),
  // Map actions to dispatch and props
  {
    addSport,
    deleteAudio,
    deleteImages,
    createRTMPChannel,
    deleteCategory,
    getCustomFields,
    createCustomFields,
    deleteFields,
    fetchSportsTeam,
    createTournament,
    addEvent,
    editShow,
    editReservedChannel,
    createTeam,
    createPlayer,
    fetchTournamentsData,
    deleteTournamentData,
    deleteKeymoment,
    deleteTeam,
    deletePlayers,
    getEventStream,
    getPlayerStream,
    getPlayersByEvents,
    createStorage,
    deleteStorage,
    editStorageDetails,
    createServer,
    getAllInviteUser,
    getUserDetail,
    getServerDetails,
    deleteServer,
    fetchMe,
    updateCustomFields,
    getEventsByCategory,
    addBulkTournament,
    addTagThroughCSV,
    addBulkTeam,
    getPackages,
    getUsersByUserIds,
    getFolder,
    addShow,
    getShows,
    deleteShows,
    uploadStoryTemplate,
    getStoryTemplates,
    testStoryTemplate,
    moveStoryTemplate,
    deleteStoryTemplate,
    getCategoryConfiguration,
    storageValidation,
    getStorageList,
    getAssignedUserOfStorage,
    updateCategoryConfiguration,
    addTenant,
    updateTenant,
    deleteTenant,
    getTenant,
    createStorageAdmin,
    editStorageDetailsAdmin,
    deleteStorageAdmin,
    getRTMPChannel,
    deleteRTMPChannel,
    updateClientSetting,
    getClientSetting,
    updateRTMPState,
    updatertmpChannel,
    getChannelDetails,
    importS3GlacierStreams,
    getDownloadVideosCSV,
    getYoutubeDownloadVideosData,
    createReservedChannle,
    listReservedChannel,
    deleteReservedChannel,
    addMediaTemplate,
    getMediaTemplate,
    editMediaTemplate,
    deleteMediaTemplate,
    getOrganizationsByIds,
    fetchSecretValues,
    deleteSecretValue,
    getCreateCategory,
    getAllCategory,
    getAllTagsById,
    deleteTagsById,
    getCreateTeams,
    getAllTeams,
    deleteTeamById,
    editTeamById,
    getAssignedStorageOrganization,
    getOrganizationStorage,
    getSingleOrganizationById,
    getCreateTournament,
    getAllTournament,
    getEditTournament,
    getDeleteTournament,
    getTotalTeams,
    addSocialMediaPlatforms,
    addUsers,
    createUserProfile,
    deleteUserProfile,
    editUserProfile,
    fetchUserDetails,
    getFeatureList,
    getOrganization,
    getOrganizationListById,
    getStorage,
    getUser,
    getUsersByOrganization,
    updateOrganization,
    updateStorageMultipleFolderPath,
    updateUser,
    updateUsers,
    addNewUser,
    assignCategoryToOrganization,
    fetchBrightCoveToken,
    getOrgDetails,
    getSportsDetail,
    getUploadPicture,
    getOrganizationConfigCategory,
    getAllDatafeedConfigsForOrganization,
    updateOrganizationMember,
    updateWorkspaceMember,
    removeOrganizationMember,
    getOrganizationUsers,
    getWorkspaceUsers,
    showSlate,
    getImages,
    getAudio,
    isValidStream,
    getTimeLineDuration,
    addSlate,
    addImages,
    addAudioToFolder,
    deleteSlate,
    getWorkspaceConfigCategory,
    getOrganizationDetails,
    getWorkspaceDetails,
    resyncIllustoResource,
    createIllustoAccount,
    getWorkspaces,
    editOrganization,
    editWorkspace,
    removeWorkspaceMember,
    validateUserAuthentication,
    syncTv2PlayerData,
    fetchTemplateConfig,
    getOrganizationWorkspaces,
    getVideoGridState,
    updateVideoData,
    resetUserPassword,
    createSocialProfile,
    deleteSocialProfile,
    updateSocialProfile,
    getSocialProfiles,
  },
)(OrganisationProfileComponent);

export default OrganisationProfile;
